import { Component, HostListener, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { api } from '../URL/api-url';
import { parseDateOnly, toApiDate } from '../CommonFunctions/date-utils';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: ['./questions.component.css']
})
export class QuestionsComponent {
  displaySideBar = true;
  width = "265px";
  addAditionalData: Array<any> = [];
  addAditionalData1: Array<any> = [];
  isEditable = true;
  enableEditIndex = null;
  @ViewChild('sigPad') sigPad;
  sigPadElement: any;
  context: any;
  isDrawing = false;
  memberHeightUnit: string = 'cm';
  memberweightUnit: string = 'lbs';
  spouseHeightUnit: string = 'cm';
  spouseWeightUnit: string = 'lbs';
  familyForm: any;
  familyMembers: any;
  isAtleastOneMember: any = false;
  isAtleastOneSpouse: any = false;
  isFamilyMember: any;
  isFamilySpouse: any;
  physicianForm: any;
  physicianForm1: any;
  additionalDetailsFormVisible = false;
  additionalDetailsFormVisible1 = false;
  insuranceForm: any;
  isSpouse: any = false;
  beneficiaries: any = [];
  spouseEdit: boolean = false;
  provinceList: any = ['ON', 'AB', 'BC'];
  configprovinceres: any;
  provincialZipcodes: any;
  postalvalue: any;
  provincelistid: any;
  state_id: any;
  statename: any;
  memberInsurance: any = {
    lifeInsurance: false,
    lifeInsuranceCoverage: '',
    criticalIllness: false,
    criticalIllnessCoverage: ''
  }
  spouseInsurance: any = {
    lifeInsurance: false,
    lifeInsuranceCoverage: '',
    criticalIllness: false,
    criticalIllnessCoverage: ''
  }
  formConfig: any;
  province: any;
  lang: any;
  selectedLanguage: any = '';
  questions: any = [
    { key: '3', label: 'In the last 12 months, have you used, in any form whatsoever, tobacco, nicotine or cannabis mixed with tobacco?' },
    { key: '4', label: 'Have you flown as a pilot, student or crew member in the last two years or do you have any intention to do so?' },
    { key: '5', label: 'Have you engaged in or do you intend to participate in scuba diving, parachuting or other hazardous sport or activity?' },
    { key: '6', label: 'Do you intend to travel or reside outside Canada or the United States for more than a month?' },
    { key: '7', label: 'Have you had a request for life, disability or critical illness insurance declined, postponed, rated or modified in any way?' },
    { key: '8', label: 'Are you now actively engaged in your occupation on a full-time basis? If “No”, please provide details including reason why you are not working on a full-time basis.' },
    { key: '9', label: 'Have you ever had or ever been treated for cancer, tumour, cyst, polyp or other growth, moles, anemia, blood disorder or any form of malignant disease?' },
    { key: '10', label: 'Have you ever had or have you ever been treated for chest pain, angina, heart attack, high blood pressure, abnormal ECG, stroke, paralysis, transient ischemic attack (TIA), elevated cholesterol, or other disorders of the heart or aorta, blood vessels or circulatory system? Diabetes, pancreatitis,thyroid or other endocrine disorder? Lung or other respiratory disease or disorder? Any disorder of the eyes (excluding near or far sightedness), ears,vocal chords or larynx including loss of speech?' },
    { key: '11', label: 'Have you ever been treated for or diagnosed with kidney, bladder, prostate (including an elevated PSA test result) or breast disorder (including cysts,lumps, biopsy or abnormal mammogram or ultrasound) or other genitourinary disorder, hepatitis B or C (including carrier), cirrhosis or other liver disorder, ulcerative colitis, Crohn’s disease or other disorder of the gastrointestinal tract?' },
    { key: '12', label: 'Have you ever had or have you ever been treated for dizziness, seizures, epilepsy, tremor, paresthesia, loss of balance, numbness, multiple sclerosis,Alzheimer’s disease, Parkinson’s disease, amyotrophic lateral sclerosis (ALS) or any other neurological disorder? Stress, anxiety, depression or any other psychiatric disorder? Disease or disorder of muscles, ligaments, tendons, bones or joints including but not limited to arthritis, lupus in any form,amputation or deformity?' },
    { key: '13', label: 'Have you ever used marijuana, heroin, morphine, cocaine, LSD, barbiturates, amphetamines, or any other drug or narcotic, except as prescribed by your physician?' },
    { key: '14a', label: 'Do you presently drink more than 12 alcoholic beverages per week? If “Yes”, state number, kind and frequency consumed.' },
    { key: '14b', label: 'Have you ever changed your pattern of drinking (increased or decreased), received advice or treatment for, or attended any rehabilitation program for alcohol or drug use?' },
    { key: '15', label: 'Have you any condition for which hospitalization, further testing, investigation or surgery has been advised, or which have not yet been done, or for which you are still awaiting results?' },
    { key: '16', label: 'Are you taking any prescribed medication? If “Yes”, state name of medication and reason for use.' },
    { key: '17', label: 'Are you aware of any symptoms or complaints regarding your health for which you have not yet consulted a physician or received treatment?' },
    { key: '18', label: 'Have you been absent from work for more than seven consecutive days within the past year due to sickness or injury?' },
    { key: '19', label: 'Has there been a variation in your weight in the past year? If “Yes”, please provide details including reason and number of pounds/kilograms gained or lost.' },
    { key: '20', label: 'Females only: Are you currently pregnant? If “Yes”, please provide your estimated due date and advise of any complications with current or past pregnancies.' },
    { key: '21', label: 'During the past 10 years, have you consulted a physician, received treatment or been hospitalized, had surgery or any test (other than routine checkup or minor injury) for any disease, disorder or ailment not already mentioned?' },
    { key: '22', label: 'Have you ever received or claimed benefits or a pension for sickness, injury or impairment?' },
    { key: '23', label: 'Do you have any pending criminal offences, criminal convictions, had your driver’s license suspended, or within the past 3 years been convicted of more than 3 traffic violations?' }
  ];

  additionalDetailsform: FormGroup = new FormGroup({
    questionNumber: new FormControl('', [Validators.required]),
    value: new FormControl('', [Validators.required]),
    additionalDetails: new FormControl('', [Validators.required]),
  });

  additionalDetailsTable = false;
  additionalDetailsForm = true;
  additionalDetailsTable1 = false;
  additionalDetailsForm1 = true;
  invalidpostalcodeprivince: boolean = false;
  invalidpostalcodeprivince1: boolean = false;
  currClient: any = '';
  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router, private http: HttpClient,) {

  }

  familyData = [
    { label: 'Father', key: 'father' },
    { label: 'Mother', key: 'mother' },
    { label: 'Brothers', key: 'brothers' },
    { label: 'Sisters', key: 'sisters' }
  ];

  familyMember = {
    father: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    mother: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    brothers: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    sisters: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
  }

  familySpouse = {
    father: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    mother: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    brothers: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
    sisters: {
      condition: "",
      ageAtOnset: "",
      ageAtDeath: ""
    },
  }
  customerid: any;
  accessToken: any;
  customerData: any;
  memberDetails: any = {};
  spouseDetails: any = {};
  plans: any;
  answers: any = [];
  answers1: any = [];

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.getLanguageTokens();
    let client = sessionStorage.getItem("currClient");
    if(client){
      this.currClient = client
    }
    this.isSpouse = sessionStorage.getItem('isSpouse') == 'true' ? true : false;
    this.customerid = sessionStorage.getItem("customerId");
    this.accessToken = sessionStorage.getItem('accessToken');
    this.getCustomerData();
    this.getPlanes();
    this.getFormConfiguration("en");
    setTimeout(() => {
      this.sigPadElement = this.sigPad.nativeElement;
      this.context = this.sigPadElement.getContext('2d');
      this.context.strokeStyle = 'black';
    }, 10000);

    this.insuranceForm = this.formBuilder.group({
      memberHeight: ['', [Validators.required]],
      memberHeightUnit: [''],
      memberWeight: ['', [Validators.required]],
      memberWeightUnit: [''],
      spouseHeight: this.isSpouse ? ['', [Validators.required]] : [''],
      spouseHeightUnit: [''],
      spouseWeight: this.isSpouse ? ['', [Validators.required]] : [''],
      spouseWeightUnit: [''],
      ...this.questions.reduce((acc: any, _: any, index: number) => {
        acc[`memberQuestion${index + 1}`] = ['', [Validators.required]],
          acc[`spouseQuestion${index + 1}`] = this.isSpouse ? ['', [Validators.required]] : [''];
        return acc;
      }, {})
    });

    this.familyMembers = [
      { name: 'Father', formControlNamePrefix: 'father' },
      { name: 'Mother', formControlNamePrefix: 'mother' },
      { name: 'Brothers', formControlNamePrefix: 'brothers' },
      { name: 'Sisters', formControlNamePrefix: 'sisters' }
    ];

    this.familyForm = this.formBuilder.group({
      memberHasConditions: ['', [Validators.required]],
      spouseHasConditions: this.isSpouse && this.isSpouse == true ? ['', [Validators.required]] : ['']
    });

    this.physicianForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      number: ['', [Validators.required, this.phoneNumberValidator()]],
      streetAddress: ['', [Validators.required]],
      city: ['', [Validators.required]],
      province: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalcodeValidator]],
      dateLastConsulted: ['', [Validators.required]],
      consultationReason: ['', [Validators.required]],
      consultationResult: ['', [Validators.required]]
    });
    this.physicianForm1 = this.formBuilder.group({
      name: ['', [Validators.required]],
      number: ['', [Validators.required, this.phoneNumberValidator()]],
      streetAddress: ['', [Validators.required]],
      city: ['', [Validators.required]],
      province: ['', [Validators.required]],
      postalCode: ['', [Validators.required, postalcodeValidator]],
      dateLastConsulted: ['', [Validators.required]],
      consultationReason: ['', [Validators.required]],
      consultationResult: ['', [Validators.required]]
    });

    this.physicianForm.get('number').valueChanges.subscribe(value => {
      const formattedValue = this.formatPhoneNumber(value);
      if (formattedValue != this.physicianForm.get('number').value) {
        this.physicianForm.get('number').setValue(formattedValue, { emitEvent: false });
      }
    });
    this.physicianForm1.get('number').valueChanges.subscribe(value => {
      const formattedValue = this.formatPhoneNumber(value);
      if (formattedValue != this.physicianForm1.get('number').value) {
        this.physicianForm1.get('number').setValue(formattedValue, { emitEvent: false });
      }
    });

    this.additionalDetailsform = this.formBuilder.group({
      questionNumber: ['', [Validators.required]],
      value: ['', [Validators.required]],
      additionalDetails: ['', [Validators.required]],
    })
  }

  getFormConfiguration(lang: any) {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerDataEndpoint = '/customer/formConfig';
    this.http.get(api.url + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
        'Lang': lang,
      }
    }).subscribe((response: any) => {

      if (response.status == 200) {
        this.formConfig=response.data;
        const provinces = response.data.states.sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
        this.configprovinceres = provinces;
        this.provinceList = provinces.map(province => province.shortName)
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  getCustomerData() {
    let customerDataEndpoint = '/customer/' + this.customerid + '/details';
    this.http.get(api.url + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.customerData = response.data;
        console.log('this.customerData', this.customerData)

        this.memberDetails.lastName = this.customerData.lastName
        this.memberDetails.firstName = this.customerData.firstName
        this.memberDetails.gender = this.customerData.gender
        this.memberDetails.dob = parseDateOnly(this.customerData.dob)
        this.memberDetails.pob = ''
        this.memberDetails.occupation = ''
        this.memberDetails.streetAddress = this.customerData.line1
        this.memberDetails.city = this.customerData.city
        this.memberDetails.province = this.customerData.province
        this.memberDetails.postalCode = this.customerData.postalCode
        this.memberDetails.telephone = this.customerData.primaryPhone
        this.memberDetails.telephone2Type = ''
        this.memberDetails.secondaryPhone = this.customerData.secondaryPhone
        this.memberDetails.email = this.customerData.email || this.customerData.primaryEmail
        this.memberDetails.memberSignature = this.customerData?.signature ? this.customerData?.signature : ''
        console.log('this.memberDetails', this.memberDetails)

        this.answers = [
          { questionNumber: '3', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '4', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '5', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '6', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '7', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '8', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '9', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '10', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '11', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '12', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '13', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '14a', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '14b', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '15', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '16', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '17', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '18', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '19', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '20', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '21', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '22', value: this.memberDetails.firstName, additionalDetails: "" },
          { questionNumber: '23', value: this.memberDetails.firstName, additionalDetails: "" },
        ]

        if (this.isSpouse) {
          this.spouseDetails.alsoMember = ''
          this.spouseDetails.spouseStatus = ''
          this.spouseDetails.cohabitationDate = ''
          this.spouseDetails.lastName = this.customerData.dependents.spouseInfo?.lastName
          this.spouseDetails.firstName = this.customerData.dependents.spouseInfo?.lastName
          this.spouseDetails.gender = this.customerData.dependents.spouseInfo?.gender
          this.spouseDetails.dob = parseDateOnly(this.customerData.dependents.spouseInfo?.dob)
          this.spouseDetails.pob = this.customerData.dependents.spouseInfo?.pob
          this.spouseDetails.occupation = ''
          this.spouseDetails.spouseSignature = this.customerData?.spouseSignature ? this.customerData?.spouseSignature : ''
          console.log('this.spouseDetails', this.spouseDetails)
          this.answers1 = [
            { questionNumber: '3', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '4', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '5', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '6', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '7', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '8', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '9', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '10', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '11', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '12', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '13', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '14a', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '14b', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '15', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '16', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '17', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '18', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '19', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '20', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '21', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '22', value: this.spouseDetails.firstName, additionalDetails: "" },
            { questionNumber: '23', value: this.spouseDetails.firstName, additionalDetails: "" },
          ]
        }

        this.beneficiaries = this.customerData?.beneficiaries.map(ben => {
          return {
            firstName: ben.firstName,
            lastName: ben.lastName,
            relationship: ben.relationship,
            percentagePayable: ben.percentage,
            trustee: ben.trusteeDetails
          }
        })
        console.log('this.beneficiaries', this.beneficiaries)
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  getPlanes() {
    let accessToken = sessionStorage.getItem('accessToken');
    let customerId = sessionStorage.getItem('customerId');
    let customerEndpoint = `/customer/v3/${customerId}/plans/false`;
    this.http.get(api.url + customerEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-type': 'applivation/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        this.plans = response.data.plans;
        for (let i = 0; i < this.plans.length; i++) {
          let additionalDetails = JSON.parse(this.plans[i].additionalDetails) || []
          console.log({ additionalDetails })
          if ("Life Insurance".includes(additionalDetails?.name?.split('-')[0].trim())) {
            if (additionalDetails?.member && Object.keys(additionalDetails.member).length > 0) {
              this.memberInsurance.lifeInsurance = true
              this.memberInsurance.lifeInsuranceCoverage = additionalDetails?.member?.coverageValue
              this.insuranceForm.patchValue({
                memberQuestion1: additionalDetails?.member?.smoker == true ? 'yes' : 'no'
              });
            }
            if (additionalDetails?.spouse && Object.keys(additionalDetails.spouse).length > 0) {
              this.spouseInsurance.lifeInsurance = true
              this.spouseInsurance.lifeInsuranceCoverage = additionalDetails?.spouse?.coverageValue
              this.insuranceForm.patchValue({
                spouseQuestion1: additionalDetails?.spouse?.smoker == true ? 'yes' : 'no'
              });
            }
          }
          if ('Critical Illness Insurance'.includes(additionalDetails?.name?.split('-')[0].trim())) {
            if (additionalDetails?.member && Object.keys(additionalDetails.member).length > 0) {
              this.memberInsurance.criticalIllness = true
              this.memberInsurance.criticalIllnessCoverage = additionalDetails?.member?.coverageValue
              this.insuranceForm.patchValue({
                memberQuestion1: additionalDetails?.member?.smoker == true ? 'yes' : 'no'
              });
            }
            if (additionalDetails?.spouse && Object.keys(additionalDetails.spouse).length > 0) {
              this.spouseInsurance.criticalIllness = true
              this.spouseInsurance.criticalIllnessCoverage = additionalDetails?.spouse?.coverageValue
              this.insuranceForm.patchValue({
                spouseQuestion1: additionalDetails?.spouse?.smoker == true ? 'yes' : 'no'
              });
            }
          }
        }
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  updateAddressForm() {
    this.physicianForm.markAllAsTouched();
    this.physicianForm1.markAllAsTouched();
    this.invalidpostalcodeprivince = false
    this.invalidpostalcodeprivince1 = false
  }

  public provincelist(event: any) {
    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });
    if (this.physicianForm.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.physicianForm.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;
        this.physicianForm.get('postalCode').markAsTouched();
        this.invalidpostalcodeprivince1 = true;
        this.physicianForm1.get('postalCode').markAsTouched();
      } else {
        this.invalidpostalcodeprivince = false;
        this.invalidpostalcodeprivince1 = false;
      }
      if (this.physicianForm.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
        this.invalidpostalcodeprivince1 = false;
      }
    }
  }

  changeTextToUppercase(event: any) {
    const inputValue = this.physicianForm.get('postalCode')?.value;
    this.physicianForm.get('postalCode')?.setValue(inputValue.toUpperCase(), { emitEvent: false });
    this.postalvalue = event.target.value;
    if (this.provincialZipcodes?.indexOf(this.postalvalue[0]) == -1) {
      this.invalidpostalcodeprivince = true;
      this.invalidpostalcodeprivince1 = true;
      this.physicianForm['postalCode'].markAsTouched();
      this.physicianForm1['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
      this.invalidpostalcodeprivince1 = false;
    }
    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
      this.invalidpostalcodeprivince1 = false;
    }
  }


  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const phoneNumberPattern = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;
      const valid = phoneNumberPattern.test(control.value);
      return valid ? null : { 'phoneNumberInvalid': { value: control.value } };
    };
  }

  sideBarDisplay(value: string) {
    this.displaySideBar = JSON.parse(value);
    if (JSON.parse(value)) {
      this.width = "0"
    }
  }

  formatPhoneNumber(number: string): string {
    number = number.replace(/\D/g, '');
    number = number.charAt(0) != '+' ? "+" + number : "" + number;
    number = number.charAt(1) != '1' ? number.charAt(0) + "1" + number.substring(1) : "" + number;
    const countryCodeStr = number.slice(0, 2);
    const areaCodeStr = number.slice(2, 5);
    const midSectionStr = number.slice(5, 8);
    const lastSectionStr = number.slice(8);
    return `${countryCodeStr} (${areaCodeStr}) ${midSectionStr}-${lastSectionStr}`;
  }

  private isValidQuestionNumber(questionNumber: any): boolean {
    if (questionNumber == '14a') {
      questionNumber = 15
    }
    if (questionNumber == '14b') {
      questionNumber = 16
    }
    return questionNumber >= 1 && questionNumber <= 23;
  }

  // Method to check for duplicate questionNumber
  private isDuplicateQuestionNumber(questionNumber: number): boolean {
    console.log('this.addAditionalData', this.addAditionalData)
    return this.addAditionalData.some(data => data.questionNumber == questionNumber);
  }

  private isDuplicateQuestionNumber1(questionNumber: number): boolean {
    console.log('this.addAditionalData1', this.addAditionalData1)
    return this.addAditionalData1.some(data => data.questionNumber == questionNumber);
  }

  getMemberQuestionKey(questionNumber: string): string {
    const mapping: { [key: string]: string } = {
      '3': '1',
      '4': '2',
      '5': '3',
      '6': '4',
      '7': '5',
      '8': '6',
      '9': '7',
      '10': '8',
      '11': '9',
      '12': '10',
      '13': '11',
      '14a': '12',
      '14b': '13',
      '15': '14',
      '16': '15',
      '17': '16',
      '18': '17',
      '19': '18',
      '20': '19',
      '21': '20',
      '22': '21',
      '23': '22'
    };

    return mapping[questionNumber] || '';
  }

  SaveadditionalDetails() {
    this.additionalDetailsform.markAllAsTouched();
    const memberQuestions = {};

    for (const key in this.insuranceForm.value) {
      if (this.insuranceForm.value.hasOwnProperty(key)) {
        if (key.startsWith('memberQuestion')) {
          const questionNumber = key.replace('memberQuestion', '');
          memberQuestions[questionNumber] = this.insuranceForm.value[key];
        }
      }
    }

    // Extract form values
    const formValue = this.additionalDetailsform.value;
    console.log({ formValue })
    const questionNumber = formValue.questionNumber;
    const value = formValue.value;
    const additionalDetails = formValue.additionalDetails;

    const key = this.getMemberQuestionKey(questionNumber);
    if (!key) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
      return;
    }
    if (questionNumber == '8') {
      if (memberQuestions[key] != 'no') {
        console.log(3)
        console.log(key, memberQuestions[key])
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
    } else {
      if (memberQuestions[key] != 'yes') {
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
    }

    if (this.additionalDetailsform.invalid) {
      return;
    }

    // Validate questionNumber
    if (!this.isValidQuestionNumber(questionNumber)) {
      return;
    }

    // Check for duplicate questionNumber
    if (this.isDuplicateQuestionNumber(questionNumber)) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ duplicate: true });
      return;
    }

    console.log(JSON.stringify(this.additionalDetailsform.value, null, 2));
    let obj = {
      questionNumber,
      value,
      additionalDetails
    };

    this.addAditionalData.push(obj);
    $("#add_more").hide();
    $(".modal-backdrop").css("display", "none");
    this.additionalDetailsform.reset();
    this.additionalDetailsTable = true;
    this.additionalDetailsForm = false;
  }

  SaveadditionalDetails1() {
    this.additionalDetailsform.markAllAsTouched();
    const spouseQuestions = {};

    for (const key in this.insuranceForm.value) {
      if (this.insuranceForm.value.hasOwnProperty(key)) {
        if (key.startsWith('spouseQuestion')) {
          const questionNumber = key.replace('spouseQuestion', '');
          spouseQuestions[questionNumber] = this.insuranceForm.value[key];
        }
      }
    }

    // Extract form values
    const formValue = this.additionalDetailsform.value;
    console.log({ formValue })
    const questionNumber = formValue.questionNumber;
    const value = formValue.value;
    const additionalDetails = formValue.additionalDetails;

    const key = this.getMemberQuestionKey(questionNumber);
    if (!key) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
      return;
    }
    if (questionNumber == '8') {
      if (spouseQuestions[key] != 'no') {
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
    } else {
      if (spouseQuestions[key] != 'yes') {
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
    }

    if (this.additionalDetailsform.invalid) {
      return;
    }

    // Validate questionNumber
    if (!this.isValidQuestionNumber(questionNumber)) {
      return;
    }

    // Check for duplicate questionNumber
    if (this.isDuplicateQuestionNumber1(questionNumber)) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ duplicate: true });
      return;
    }

    console.log(JSON.stringify(this.additionalDetailsform.value, null, 2));
    let obj = {
      questionNumber,
      value,
      additionalDetails
    };

    this.addAditionalData1.push(obj);
    $("#add_more").hide();
    $(".modal-backdrop").css("display", "none");
    this.additionalDetailsform.reset();
    this.additionalDetailsTable1 = true;
    this.additionalDetailsForm1 = false;
  }

  // Function to update additional details
  updateAdditionalDetails(): void {
    if (this.additionalDetailsform.invalid) {
      console.log('Form is invalid.');
      return;
    }

    const formValue = this.additionalDetailsform.value;
    const questionNumber = formValue.questionNumber;
    const value = formValue.value;
    const additionalDetails = formValue.additionalDetails;

    // Find the index of the object to update
    const index = this.addAditionalData.findIndex(item => item.questionNumber == questionNumber);

    if (index == -1) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ notFound: true });
      return;
    }

    // Update the object
    this.addAditionalData[index] = {
      questionNumber,
      value,
      additionalDetails
    };

    // Optionally reset form and hide modal
    this.additionalDetailsform.reset();
    $("#edit_question").hide();
    $(".modal-backdrop").css("display", "none");
    this.additionalDetailsTable = true;
    this.additionalDetailsFormVisible = false;
  }

  updateAdditionalDetails1(): void {
    if (this.additionalDetailsform.invalid) {
      console.log('Form is invalid.');
      return;
    }

    const formValue = this.additionalDetailsform.value;
    const questionNumber = formValue.questionNumber;
    const value = formValue.value;
    const additionalDetails = formValue.additionalDetails;

    const index = this.addAditionalData1.findIndex(item => item.questionNumber == questionNumber);

    if (index == -1) {
      this.additionalDetailsform.controls['questionNumber'].setErrors({ notFound: true });
      return;
    }

    this.addAditionalData1[index] = {
      questionNumber,
      value,
      additionalDetails
    };

    this.additionalDetailsform.reset();
    $("#edit_question").hide();
    $(".modal-backdrop").css("display", "none");
    this.additionalDetailsTable1 = true;
    this.additionalDetailsFormVisible1 = false;
  }

  SaveadditionalDetails12() {
    const invalid: any = [];
    const controls: any = this.insuranceForm.controls;


    for (let name in controls) {
      if (controls[name].invalid) {
        console.log(name)
      }
    }

  }

  dobOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    // Digits, '-' and letters: the pickers display MMM-DD-YYYY, so the month
    // has to be typeable as text (May-10-1990).
    if ((charCode >= 48 && charCode <= 57) || charCode === 45) {
      return true;
    }
    return (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122);
  }

  addMore() {
    $(".modal-backdrop").css("display", "flex");
    this.additionalDetailsform.reset();
    this.spouseEdit = false;
  }

  addMore1() {
    $(".modal-backdrop").css("display", "flex");
    this.additionalDetailsform.reset();
    this.spouseEdit = true;
  }

  closeMore() {
    this.additionalDetailsform.reset();
  }

  closeEdit() {
    this.additionalDetailsform.reset();
  }

  deleteQuestion(qNumber) {
    Swal.fire({
      title: this.lang?.Error,
      text: 'Would you like to delete this question details?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.addAditionalData = this.addAditionalData.filter(data => data.questionNumber != qNumber)
        if (this.addAditionalData.length == 0) {
          this.additionalDetailsTable = false
          this.additionalDetailsForm = true;
        }
      }
    })
  }

  deleteQuestion1(qNumber) {
    Swal.fire({
      title: this.lang?.Error,
      text: 'Would you like to delete this question details?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.addAditionalData1 = this.addAditionalData1.filter(data => data.questionNumber != qNumber)
        if (this.addAditionalData1.length == 0) {
          this.additionalDetailsTable1 = false
          this.additionalDetailsForm1 = true;
        }
      }
    })
  }

  alphabatesOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (
      (charCode >= 65 && charCode <= 90) ||    // A-Z
      (charCode >= 97 && charCode <= 122) ||   // a-z
      (charCode >= 192 && charCode <= 255) || //À-ÖØ-öø-ÿ
      // (charCode >= 48 && charCode <= 57) ||    // 0-9
      charCode == 32 //space
      || charCode == 45 // - hypen
      || charCode == 46 //.
    )
      return true;
    else
      return false;
  }

  addQuestion() {
    console.log('this.additionalDetailsform', this.additionalDetailsform)
    this.spouseEdit ? this.SaveadditionalDetails1() : this.SaveadditionalDetails()
  }

  editQuestion() {
    console.log('this.additionalDetailsform', this.additionalDetailsform);
    this.spouseEdit ? this.updateAdditionalDetails1() : this.updateAdditionalDetails()
  }

  edit_Question(question) {
    this.spouseEdit = false;
    console.log(question)
    $(".modal-backdrop").css("display", "flex");
    this.additionalDetailsform = this.formBuilder.group({
      questionNumber: [question.questionNumber],
      value: [question.value],
      additionalDetails: [question.additionalDetails],
    })
    $("#edit_question").show();
  }
  edit_Question1(question) {
    this.spouseEdit = true;
    console.log(question)
    $(".modal-backdrop").css("display", "flex");
    this.additionalDetailsform = this.formBuilder.group({
      questionNumber: [question.questionNumber],
      value: [question.value],
      additionalDetails: [question.additionalDetails],
    })
    $("#edit_question").show();
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e: any) {
    this.isDrawing = false;
  }

  onMouseDown(e: any) {
    this.isDrawing = true;
    const coords = this.relativeCoords(e);
    this.context.moveTo(coords.x, coords.y);
  }

  onMouseMove(e: any) {
    if (this.isDrawing) {
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.context.stroke();
    }
  }

  isConditionMetMember(i: number): boolean {
    const memberQuestionValue = this.insuranceForm.get(`memberQuestion${i}`)?.value;
    if (i === 6) {
      return memberQuestionValue === 'no';
    } else {
      return memberQuestionValue === 'yes';
    }
  }

  isConditionMetSpouse(i: number): boolean {
    const memberQuestionValue = this.insuranceForm.get(`spouseQuestion${i}`)?.value;
    if (i === 6) {
      return memberQuestionValue === 'no';
    } else {
      return memberQuestionValue === 'yes';
    }
  }

  clearSignature() {
    this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
  }

  private relativeCoords(event: any) {
    const bounds = event.target.getBoundingClientRect();
    const x = event.clientX - bounds.left;
    const y = event.clientY - bounds.top;
    return { x: x, y: y };
  }
  language(event: any) {
  }

  changeFamilyMember = (val: boolean) => {
    this.isFamilyMember = val;
  }
  changeFamilySpouse = (val: boolean) => {
    this.isFamilySpouse = val;
  }

  get client() {
    return this.insuranceForm.controls;
  }

  validateFamilyHistory(family) {
    const members = [family.father, family.mother, family.brothers, family.sisters];

    for (const member of members) {
      if (member.condition && member.ageAtOnset) {
        return true;
      }
    }

    return false;
  }
  validateFamilyMember() {
    if (this.familyForm.value.memberHasConditions == true) {
      const family = this.familyMember
      for (let key in family) {
        if (family.hasOwnProperty(key)) {
          const member = family[key];
          if (member.condition != "" && member.ageAtOnset != "") {
            this.isAtleastOneMember = false;
            return true;
          } else {
            this.isAtleastOneMember = true;
            Swal.fire({
              title: this.lang?.Error,
              text: this.lang?.Please_check_all_fields_are_entered
            })
            return;
          }
        }
      }
    }
    if (this.isSpouse && this.familyForm.value.spouseHasConditions == true) {
      const family = this.familySpouse
      for (let key in family) {
        if (family.hasOwnProperty(key)) {
          const spouse = family[key];
          if (spouse.condition != "" && spouse.ageAtOnset != "") {
            this.isAtleastOneSpouse = false;
            return true;
          } else {
            this.isAtleastOneSpouse = true;
            Swal.fire({
              title: this.lang?.Error,
              text: this.lang?.Please_check_all_fields_are_entered
            })
            return;
          }
        }
      }
    }
    return true;
  }

  handleSubmit = () => {
    console.log('handleSubmit')
    this.insuranceForm.markAllAsTouched();
    this.familyForm.markAllAsTouched();
    this.physicianForm.markAllAsTouched();
    this.physicianForm1.markAllAsTouched();

    const date = this.physicianForm.value.dateLastConsulted;
    this.physicianForm.patchValue({
      dateLastConsulted: date.toString().slice(0, 10)
    });
    const date1 = this.physicianForm.value.dateLastConsulted;
    this.physicianForm1.patchValue({
      dateLastConsulted: date1.toString().slice(0, 10)
    });

    this.addAditionalData = this.answers;
    this.addAditionalData1 = this.answers1;


    if (this.familyForm.value.memberHasConditions && !this.validateFamilyHistory(this.familyMember)) {
      this.isAtleastOneMember = true;
      console.log('member', this.isAtleastOneMember)
      Swal.fire({
        title: this.lang?.Error,
        text: this.lang?.Please_check_all_fields_are_entered
      })
      return;
    } else {
      this.isAtleastOneMember = false;
    }

    if (this.isSpouse && this.familyForm.value.spouseHasConditions && !this.validateFamilyHistory(this.familySpouse)) {
      console.log('spouse', this.isAtleastOneSpouse)
      this.isAtleastOneSpouse = true;
      Swal.fire({
        title: this.lang?.Error,
        text: this.lang?.Please_check_all_fields_are_entered
      })
      return;
    } else {
      this.isAtleastOneSpouse = false;
    }

    console.log('this.memberDetails', this.memberDetails)
    console.log('this.spouseDetails', this.spouseDetails)
    console.log('this.memberInsurance', this.memberInsurance)
    console.log('this.spouseInsurance', this.spouseInsurance)

    if (this.memberDetails.pob == '') {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_enter_member_s_place_of_birth })
      return;
    }

    if (this.memberDetails.occupation == '') {
      Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_enter_member_s_occupation })
      return;
    }

    if (this.isSpouse) {
      if (this.spouseDetails.pob == '') {
        Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_enter_spouse_s_place_of_birth })
        return;
      }

      if (this.spouseDetails.occupation == '') {
        Swal.fire({ title: this.lang?.Error, text: this.lang?.Please_enter_spouse_s_occupation })
        return;
      }
    }

    const memberQuestions = {};
    for (const key in this.insuranceForm.value) {
      if (this.insuranceForm.value.hasOwnProperty(key)) {
        if (key.startsWith('memberQuestion')) {
          const questionNumber = key.replace('memberQuestion', '');
          memberQuestions[questionNumber] = this.insuranceForm.value[key];
        }
      }
    }
    const spouseQuestions = {};
    for (const key in this.insuranceForm.value) {
      if (this.insuranceForm.value.hasOwnProperty(key)) {
        if (key.startsWith('spouseQuestion')) {
          const questionNumber = key.replace('spouseQuestion', '');
          spouseQuestions[questionNumber] = this.insuranceForm.value[key];
        }
      }
    }
    console.log({ memberQuestions, spouseQuestions })
    console.log('this.addAditionalData', this.addAditionalData)
    console.log('this.addAditionalData1', this.addAditionalData1)
    const additionalData: any = []
    const additionalData1: any = []
    for (let i = 3; i <= 24; i++) {
      let questionNumber = i.toString()
      if (i == 14) {
        questionNumber = '14a'
      }
      if (i == 15) {
        questionNumber = '14b'
      }
      if (i > 15) {
        questionNumber = (i - 1).toString()
      }
      const key = this.getMemberQuestionKey(questionNumber);
      if (!key) {
        this.additionalDetailsform.controls['questionNumber'].setErrors({ cannotAdd: true });
        return;
      }
      const additional = this.addAditionalData.find(data => data.questionNumber.toString() == questionNumber);
      const additional1 = this.addAditionalData1.find(data => data.questionNumber.toString() == questionNumber);
      if (questionNumber == '8') {
        if (memberQuestions[key] == 'no' && additional.additionalDetails == "") {
          Swal.fire({
            title: this.lang?.Error,
            text: this.lang?.Please_check_all_fields_are_entered
          })
          return;
        } else if (memberQuestions[key] == 'no' && additional) { additionalData.push(additional); }
        if (this.isSpouse && spouseQuestions[key] == 'no' && additional1.additionalDetails == "") {
          Swal.fire({
            title: this.lang?.Error,
            text: this.lang?.Please_check_all_fields_are_entered
          })
          return;
        } else if (memberQuestions[key] == 'no' && additional1) { additionalData1.push(additional1); }
      } else {
        if (memberQuestions[key] == 'yes' && additional.additionalDetails == "") {
          Swal.fire({
            title: this.lang?.Error,
            text: this.lang?.Please_check_all_fields_are_entered
          })
          return;
        } else if (memberQuestions[key] == 'yes' && additional) { additionalData.push(additional); }
        if (this.isSpouse && spouseQuestions[key] == 'yes' && additional1.additionalDetails == "") {
          Swal.fire({
            title: this.lang?.Error,
            text: this.lang?.Please_check_all_fields_are_entered
          })
          return;
        } else if (memberQuestions[key] == 'yes' && additional1) { additionalData1.push(additional1); }
      }
    }
    console.log({ additionalData, additionalData1 })
    console.log('this.physicianForm1', this.physicianForm1.value);
    console.log('this.insuranceForm', this.insuranceForm.value);
    console.log('this.familyForm', this.familyForm.value);
    console.log('this.physicianForm', this.physicianForm.value);

    for (const control in this.insuranceForm.controls) {
      if (this.insuranceForm.controls[control].invalid) {
        console.log(`Control ${control} is invalid`, this.insuranceForm.controls[control].errors);
      }
    }
    for (const control in this.familyForm.controls) {
      if (this.familyForm.controls[control].invalid) {
        console.log(`Control ${control} is invalid`, this.familyForm.controls[control].errors);
      }
    }
    for (const control in this.physicianForm.controls) {
      if (this.physicianForm.controls[control].invalid) {
        console.log(`Control ${control} is invalid`, this.physicianForm.controls[control].errors);
      }
    }
    if (this.physicianForm.value.number.length != 17) {
      this.physicianForm.controls['number'].setErrors({ invalidPhoneNumber: true });
      Swal.fire({
        title: this.lang?.Error,
        text: this.lang?.Please_check_all_fields_are_entered
      })
      return;
    }
    if (this.isSpouse) {
      for (const control in this.physicianForm1.controls) {
        if (this.physicianForm1.controls[control].invalid) {
          console.log(`Control ${control} is invalid`, this.physicianForm1.controls[control].errors);
        }
      }
      if (this.physicianForm1.value.number.length != 17) {
        this.physicianForm1.controls['number'].setErrors({ invalidPhoneNumber: true });
        Swal.fire({
          title: this.lang?.Error,
          text: this.lang?.Please_check_all_fields_are_entered
        })
        return;
      }
    }
    if (!this.insuranceForm.valid || !this.familyForm.valid || !this.physicianForm.valid) {
      console.log('insurance', this.insuranceForm.status);
      console.log('familyForm', this.familyForm.status);
      console.log('physicianForm', this.physicianForm.status);
      Swal.fire({
        title: this.lang?.Error,
        text: this.lang?.Please_check_all_fields_are_entered
      })
      return;
    }
    if (this.isSpouse && !this.physicianForm1.valid) {
      console.log('physicianForm1 invalid', this.physicianForm1.status);
      Swal.fire({
        title: this.lang?.Error,
        text: this.lang?.Please_check_all_fields_are_entered
      })
      return
    }

    let familyHistoryAdditionalDetails: [{
      relationship: string,
      condition: string,
      ageAtDiagnosis: string,
      ageAtDeath: string
    }] = [{
      relationship: '',
      condition: '',
      ageAtDiagnosis: '',
      ageAtDeath: ''
    }]
    familyHistoryAdditionalDetails.splice(0, 1);
    for (const [relationship, details] of Object.entries(this.familyMember)) {
      familyHistoryAdditionalDetails.push({
        relationship: relationship,
        condition: details.condition,
        ageAtDiagnosis: details.ageAtOnset,
        ageAtDeath: details.ageAtDeath
      });
    }
    let familyHistoryAdditionalDetails1: [{
      relationship: string,
      condition: string,
      ageAtDiagnosis: string,
      ageAtDeath: string
    }] = [{
      relationship: '',
      condition: '',
      ageAtDiagnosis: '',
      ageAtDeath: ''
    }]
    familyHistoryAdditionalDetails1.splice(0, 1);
    for (const [relationship, details] of Object.entries(this.familySpouse)) {
      familyHistoryAdditionalDetails1.push({
        relationship: relationship,
        condition: details.condition,
        ageAtDiagnosis: details.ageAtOnset,
        ageAtDeath: details.ageAtDeath
      });
    }

    const member = {
      height: this.insuranceForm.value.memberHeight,
      heightUnit: this.memberHeightUnit,
      weight: this.insuranceForm.value.memberWeight,
      weightUnit: this.memberweightUnit,
      isTobaccoUser: this.insuranceForm.value.memberQuestion1,
      isPilot: this.insuranceForm.value.memberQuestion2,
      doneHazardousActivity: this.insuranceForm.value.memberQuestion3,
      travelOutsideCanadaUS: this.insuranceForm.value.memberQuestion4,
      lifeInsuranceQuestion: this.insuranceForm.value.memberQuestion5,
      engagedFullTimeOccupation: this.insuranceForm.value.memberQuestion6,
      hadMalignantDiease: this.insuranceForm.value.memberQuestion7,
      hadDisorder: this.insuranceForm.value.memberQuestion8,
      hadGastrointestinalDisorder: this.insuranceForm.value.memberQuestion9,
      hadDeformity: this.insuranceForm.value.memberQuestion10,
      hasUsedDrugs: this.insuranceForm.value.memberQuestion11,
      drinksPerWeek: this.insuranceForm.value.memberQuestion12,
      changedDrinkingPattern: this.insuranceForm.value.memberQuestion13,
      hospitalizationResults: this.insuranceForm.value.memberQuestion14,
      takingPrescribedMedicine: this.insuranceForm.value.memberQuestion15,
      conditionPendingTreatment: this.insuranceForm.value.memberQuestion16,
      workAbsence: this.insuranceForm.value.memberQuestion17,
      weightVariation: this.insuranceForm.value.memberQuestion18,
      isPregnant: this.insuranceForm.value.memberQuestion19,
      hasReceivedTreatment: this.insuranceForm.value.memberQuestion20,
      claimedBenefits: this.insuranceForm.value.memberQuestion21,
      pendingCriminalOffences: this.insuranceForm.value.memberQuestion22,
      familyHistoryQuestion: this.isFamilyMember,
      familyHistoryAdditionalDetails: this.isFamilyMember ? familyHistoryAdditionalDetails : [],
      physicianInformation: this.physicianForm.value,
      additionalDetails: additionalData
    }
    const spouse = {
      height: this.insuranceForm.value.spouseHeight,
      heightUnit: this.spouseHeightUnit,
      weight: this.insuranceForm.value.spouseWeight,
      weightUnit: this.spouseWeightUnit,
      isTobaccoUser: this.insuranceForm.value.spouseQuestion1,
      isPilot: this.insuranceForm.value.spouseQuestion2,
      doneHazardousActivity: this.insuranceForm.value.spouseQuestion3,
      travelOutsideCanadaUS: this.insuranceForm.value.spouseQuestion4,
      lifeInsuranceQuestion: this.insuranceForm.value.spouseQuestion5,
      engagedFullTimeOccupation: this.insuranceForm.value.spouseQuestion6,
      hadMalignantDiease: this.insuranceForm.value.spouseQuestion7,
      hadDisorder: this.insuranceForm.value.spouseQuestion8,
      hadGastrointestinalDisorder: this.insuranceForm.value.spouseQuestion9,
      hadDeformity: this.insuranceForm.value.spouseQuestion10,
      hasUsedDrugs: this.insuranceForm.value.spouseQuestion11,
      drinksPerWeek: this.insuranceForm.value.spouseQuestion12,
      changedDrinkingPattern: this.insuranceForm.value.spouseQuestion13,
      hospitalizationResults: this.insuranceForm.value.spouseQuestion14,
      takingPrescribedMedicine: this.insuranceForm.value.spouseQuestion15,
      conditionPendingTreatment: this.insuranceForm.value.spouseQuestion16,
      workAbsence: this.insuranceForm.value.spouseQuestion17,
      weightVariation: this.insuranceForm.value.spouseQuestion18,
      isPregnant: this.insuranceForm.value.spouseQuestion19,
      hasReceivedTreatment: this.insuranceForm.value.spouseQuestion20,
      claimedBenefits: this.insuranceForm.value.spouseQuestion21,
      pendingCriminalOffences: this.insuranceForm.value.spouseQuestion22,
      familyHistoryQuestion: this.isFamilySpouse,
      familyHistoryAdditionalDetails: this.isFamilySpouse ? familyHistoryAdditionalDetails1 : [],
      physicianInformation: this.physicianForm1.value,
      additionalDetails: additionalData1
    }

    if (this.isSpouse) {
      const obj = {
        member,
        memberInfo: { ...this.memberDetails, dob: toApiDate(this.memberDetails.dob) },
        memberInsurance: this.memberInsurance,
        spouse,
        spouseInfo: { ...this.spouseDetails, dob: toApiDate(this.spouseDetails.dob) },
        spouseInsurance: this.spouseInsurance,
        beneficiaries: this.beneficiaries,
        dateSigned: this.getCurrentDateFormatted()
      };
      console.log({ obj })
      this.postQuestions(obj);
    } else {
      const obj = {
        member,
        memberInfo: { ...this.memberDetails, dob: toApiDate(this.memberDetails.dob) },
        memberInsurance: this.memberInsurance,
        spouseInsurance: this.spouseInsurance,
        beneficiaries: this.beneficiaries,
        dateSigned: this.getCurrentDateFormatted()
      }
      console.log({ obj })
      this.postQuestions(obj);
    }
  }

  navigateToHome() {
    this.router.navigate([`home`]);
  }

  getCurrentDateFormatted(): string {
    const now = new Date(Date.now());

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
    const day = String(now.getDate()).padStart(2, '0'); // Ensure two digits

    return `${year}-${month}-${day}`;
  }
  postQuestions = (obj) => {
    var endPoint = `/customer/${this.customerid}/iafg/questionaire`
    this.http.post(api.url + endPoint, obj, {
      headers: {
        Authorization: 'Bearer ' + this.accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      if (response.status == 200) {
        const responseData = response.data;
        console.log('responseData', responseData)
        Swal.fire({ title: this.lang?.Info, text: this.lang?.Medical_Questionnaire_is_submitted_successfully_You_will_be_notified_once_processed_for_Approval })
          .then((result) => {
            if (result.value) {
              if(this.currClient){
                    this.router.navigate([`${this.currClient}/home`]);
                  }else{
                    this.router.navigate(['home']);
                  }
            } else {
               if(this.currClient){
                    this.router.navigate([`${this.currClient}/home`]);
                  }else{
                    this.router.navigate(['home']);
                  }
            }
          })
      }
      else {
        Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: response.message })
      }
    }, (error) => {
      Swal.fire({ allowOutsideClick: false, title: this.lang?.Info, text: error.error.error.message })
    });
  }

  public getLanguageTokens() {
    let body = {
      "project": "Member Portal",
      "url": "Questions"
    }
    this.http
      .post(api.lang + 'string/project-url-strings', body, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          this.lang = {};
          this.selectedLanguage = sessionStorage.getItem('language') || 'English'
          for (let token of response.strings) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          console.log(this.lang)
          this.updateQuestions();
        }
      )
  }

  updateQuestions = ()=>{
    this.questions = [
      { key: '3', label: this.lang?.In_the_last_12_months_have_you_used_in_any_form_whatsoever_tobacco_nicotine_or_cannabis_mixed_with_tobacco },
      { key: '4', label: this.lang?.Have_you_flown_as_a_pilot_student_or_crew_member_in_the_last_two_years_or_do_you_have_any_intention_to_do_so },
      { key: '5', label: this.lang?.Have_you_engaged_in_or_do_you_intend_to_participate_in_scuba_diving_parachuting_or_other_hazardous_sport_or_activity },
      { key: '6', label: this.lang?.Do_you_intend_to_travel_or_reside_outside_Canada_or_the_United_States_for_more_than_a_month },
      { key: '7', label: this.lang?.Have_you_had_a_request_for_life_disability_or_critical_illness_insurance_declined_postponed_rated_or_modified_in_any_way },
      { key: '8', label: this.lang?.Are_you_now_actively_engaged_in_your_occupation_on_a_full_time_basis_If_No_please_provide_details_including_reason_why_you_are_not_working_on_a_full_time_basis },
      { key: '9', label: this.lang?.Have_you_ever_had_or_ever_been_treated_for_cancer_tumour_cyst_polyp_or_other_growth_moles_anemia_blood_disorder_or_any_form_of_malignant_disease },
      { key: '10', label: this.lang?.Have_you_ever_had_or_have_you_ever_been_treated_for_chest_pain_angina_heart_attack_high_blood_pressure_abnormal_ECG_stroke_paralysis_transient_ischemic_attack_TIA_elevated_cholesterol_or_other_disorders_of_the_heart_or_aorta_blood_vessels_or_circulatory_system_Diabetes_pancreatitis_thyroid_or_other_endocrine_disorder_Lung_or_other_respiratory_disease_or_disorder_Any_disorder_of_the_eyes_excluding_near_or_far_sightedness_ears_vocal_chords_or_larynx_including_loss_of_speech },
      { key: '11', label: this.lang?.Have_you_ever_been_treated_for_or_diagnosed_with_kidney_bladder_prostate_including_an_elevated_PSA_test_result_or_breast_disorder_including_cysts_lumps_biopsy_or_abnormal_mammogram_or_ultrasound_or_other_genitourinary_disorder_hepatitis_B_or_C_including_carrier_cirrhosis_or_other_liver_disorder_ulcerative_colitis_Crohn_s_disease_or_other_disorder_of_the_gastrointestinal_tract },
      { key: '12', label: this.lang?.Have_you_ever_had_or_have_you_ever_been_treated_for_dizziness_seizures_epilepsy_tremor_paresthesia_loss_of_balance_numbness_multiple_sclerosis_Alzheimer_s_disease_Parkinson_s_disease_amyotrophic_lateral_sclerosis_ALS_or_any_other_neurological_disorder_Stress_anxiety_depression_or_any_other_psychiatric_disorder_Disease_or_disorder_of_muscles_ligaments_tendons_bones_or_joints_including_but_not_limited_to_arthritis_lupus_in_any_form_amputation_or_deformity },
      { key: '13', label: this.lang?.Have_you_ever_used_marijuana_heroin_morphine_cocaine_LSD_barbiturates_amphetamines_or_any_other_drug_or_narcotic_except_as_prescribed_by_your_physician },
      { key: '14a', label: this.lang?.Do_you_presently_drink_more_than_12_alcoholic_beverages_per_week_If_Yes_state_number_kind_and_frequency_consumed },
      { key: '14b', label: this.lang?.Have_you_ever_changed_your_pattern_of_drinking_increased_or_decreased_received_advice_or_treatment_for_or_attended_any_rehabilitation_program_for_alcohol_or_drug_use },
      { key: '15', label: this.lang?.Have_you_any_condition_for_which_hospitalization_further_testing_investigation_or_surgery_has_been_advised_or_which_have_not_yet_been_done_or_for_which_you_are_still_awaiting_results },
      { key: '16', label: this.lang?.Are_you_taking_any_prescribed_medication_If_Yes_state_name_of_medication_and_reason_for_use },
      { key: '17', label: this.lang?.Are_you_aware_of_any_symptoms_or_complaints_regarding_your_health_for_which_you_have_not_yet_consulted_a_physician_or_received_treatment },
      { key: '18', label: this.lang?.Have_you_been_absent_from_work_for_more_than_seven_consecutive_days_within_the_past_year_due_to_sickness_or_injury },
      { key: '19', label: this.lang?.Has_there_been_a_variation_in_your_weight_in_the_past_year_If_Yes_please_provide_details_including_reason_and_number_of_pounds_kilograms_gained_or_lost },
      { key: '20', label: this.lang?.Females_only_Are_you_currently_pregnant_If_Yes_please_provide_your_estimated_due_date_and_advise_of_any_complications_with_current_or_past_pregnancies },
      { key: '21', label: this.lang?.During_the_past_10_years_have_you_consulted_a_physician_received_treatment_or_been_hospitalized_had_surgery_or_any_test_other_than_routine_checkup_or_minor_injury_for_any_disease_disorder_or_ailment_not_already_mentioned },
      { key: '22', label: this.lang?.Have_you_ever_received_or_claimed_benefits_or_a_pension_for_sickness_injury_or_impairment },
      { key: '23', label: this.lang?.Do_you_have_any_pending_criminal_offences_criminal_convictions_had_your_driver_s_license_suspended_or_within_the_past_3_years_been_convicted_of_more_than_3_traffic_violations }
    ];
  }
}

export function postalcodeValidator(control: FormControl): { [key: string]: any } | null {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null
}